module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EH9C1K/cover.jpeg?1734377734382",
      "alt": "This image is the cover for the book Bayou Underground"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bayou Underground\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A veteran music journalist explores rock-n-roll’s bayou roots in “a jolting 18-track joy ride [that] unlocks secrets and back-stories worth savoring” ("), _c('i', [_vm._v("The Wall Street Journal")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The bayou of the American south—stretching from Houston, Texas, to Mobile, Alabama—is a world all its own, with a rich cultural heritage that has had an outsized influence on musicians across the globe. In this unique study of marsh music, Dave Thompson goes beyond the storied stomping grounds of New Orleans to discover secret legends and vivid mythology in the surrounding wilderness."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Bayou Underground")]), _vm._v(", the people who have called the bayou home—such as Bob Dylan, Jerry Reed, Nick Cave, Bo Didley, a one-armed Cajun backwoodsman, and gator hunter named Amos Moses—are unearthed through their own words, their lives and music, and interviews with residents from the region. Included interviews with legendary musicians like Jerry Reed and Bo Didley, "), _c('i', [_vm._v("Bayou Underground")]), _vm._v(" is part travelogue, part social history, and part lament for a way of life that has now all but disappeared.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dave Thompson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ECW Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0